// extracted by mini-css-extract-plugin
export default {"title":"PurchasePickedTitle-module--title--eacea"};